<!-- <div class="stripe-banner" id="stripBanner">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <p><b>Upgrade Alert!</b>  Trinka AI is now <b>40%</b> more powerful. It's much faster, more accurate, and corrects more errors than ever before. <span class="d-block">Also, note that Trinka  <b>does not use ChatGPT/GPT-X</b>. It uses our own proprietary patented AI technology for grammar corrections and suggestions. 🎉 </span></p>
            </div>
        </div>
    </div>
</div> -->

<header class="wrapper bg-soft-primary" id="header" [ngClass]="{'headerSticky' : true, 'sticky' : notSticky}">
    <nav class="navbar navbar-expand-xl center-nav transparent navbar-light">
      <div class="container flex-lg-row flex-nowrap align-items-center">
        <div class="navbar-brand w-100">
          <a [routerLink]="['/']">
            <img src="assets/images/trinka_logo.svg" width="183" height="73" alt="文法チェッカー">
          </a>
        </div>
        <div class="navbar-collapse offcanvas offcanvas-nav offcanvas-start justify-content-end" [ngClass]="{'show': isMenuActive}">
          <div class="offcanvas-header d-xl-none">
            <img src="assets/images/trinka_logo.svg" loading="lazy" decoding="async" width="140" alt="文法チェッカー">
            <button type="button" class="btn-close" (click)="closeCanvasMenu()" aria-label="Close">
                <svg width="62" height="62" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M46.5 15.5L15.5 46.5" stroke="#4D4D4D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M15.5 15.5L46.5 46.5" stroke="#4D4D4D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
          </div>
          <div class="offcanvas-body ms-lg-auto d-flex flex-column h-100">
            <ul class="navbar-nav">
                <li class="nav-item dropdown dropdown-mega" >
                    <p class="nav-link dropdown-toggle" (click)="toggleClass($event)" data-toggle="dropdown"><span>製品情報</span> <img src="assets/icons/chevron-up.svg" alt="アイコン" /></p>
                    <ul class="dropdown-menu mega-menu">
                        <li class="mega-menu-content row">
                            <div class="col-12 dflex mega-card">
                                <div class="menu-card features-card c-card">
                                    <h3 class="mb-40" (click)="closeCanvasMenu()"><a [routerLink]="['/features']">機能</a></h3>
                                    <div class="media-card">
                                        <a [routerLink]="['/features/grammar-checker']">
                                            <div class="media" (click)="closeCanvasMenu()">
                                                <div class="media-left">
                                                    <img src="assets/images/menu-icons/grammar-checker.svg" loading="lazy" decoding="async" alt="文法チェッカー" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>文法チェッカー</h5>
                                                    <p>高度な文法チェックで英文を総合的に改善します</p>
                                                </div>
                                            </div>
                                        </a>
                                        <a [routerLink]="['/features/inclusive-language-check']">
                                            <div class="media" (click)="closeCanvasMenu()">
                                                <div class="media-left">
                                                    <img src="assets/images/menu-icons/inclusive-language.svg" loading="lazy" decoding="async" alt="包括的な言語チェック" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>不適切な言葉遣いの検出</h5>
                                                    <p>不適切な言葉遣いや偏向のある表現を検出し修正します</p>
                                                </div>
                                            </div>
                                        </a>
                                        <a [routerLink]="['/features/paraphraser']">
                                            <div class="media" (click)="closeCanvasMenu()">
                                                <div class="media-left">
                                                    <img src="assets/images/menu-icons/pharaphraser.svg" loading="lazy" decoding="async" alt="言い換える" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>パラフレーズツール</h5>
                                                    <p>原文の意味を保ちつつ、最適な代替表現を提案します</p>
                                                </div>
                                            </div>
                                        </a>
                                        <a [routerLink]="['/features/consistency-check']">
                                            <div class="media" (click)="closeCanvasMenu()">
                                                <div class="media-left">
                                                    <img src="assets/images/menu-icons/consistency.svg" loading="lazy" decoding="async" alt="整合性チェック" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>用語統一チェック</h5>
                                                    <p>細かい用語の不統一であっても検出し修正します</p>
                                                </div>
                                            </div>
                                        </a>
                                        <a href="https://www.trinka.ai/jp/features/auto-file-edit">
                                            <div class="media" (click)="closeCanvasMenu()">
                                                <div class="media-left">
                                                    <img src="assets/images/menu-icons/proofread.svg" loading="lazy" decoding="async" alt="校正ファイル" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>ファイル自動校正</h5>
                                                    <p>MS Word形式のファイルがそのまま校正できて時間の節約に</p>
                                                </div>
                                            </div>
                                        </a>
                                        <a [routerLink]="['/features/personal-dictionary']">
                                            <div class="media" (click)="closeCanvasMenu()">
                                                <div class="media-left">
                                                    <img src="assets/images/menu-icons/personal-dictionary.svg" loading="lazy" decoding="async" alt="個人辞書" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>マイ・ディクショナリー</h5>
                                                    <p>自分専用の辞書への単語追加で新語・固有名詞のスペルアラートを回避</p>
                                                </div>
                                            </div>
                                        </a>
                                        <a [routerLink]="['/features/latex-grammar-checker']">
                                            <div class="media" (click)="closeCanvasMenu()">
                                                <div class="media-left">
                                                    <img src="assets/images/menu-icons/spell-check.svg" loading="lazy" decoding="async" alt="スペルチェック" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>LaTeXファイル自動校正</h5>
                                                    <p>LaTeXファイルの自動校正機能で作業を効率化</p>
                                                </div>
                                            </div>
                                        </a>
                                        <a [routerLink]="['/features/legal-writing']">
                                            <div class="media" (click)="closeCanvasMenu()">
                                                <div class="media-left">
                                                    <img src="assets/images/menu-icons/legal-writing.svg" loading="lazy" decoding="async" alt="法的文書" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>法務・法律関係文書校正</h5>
                                                    <p>法律関係の文書も瞬時に改善します</p>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                                <div class="menu-card hr-line c-card"></div>
                                <div class="menu-card reports-card c-card">
                                    <h3 class="mb-40">レポート</h3>
                                    <div class="media-card">
                                        <a [routerLink]="['/features/plagiarism-check']">
                                            <div class="media" (click)="closeCanvasMenu()">
                                                <div class="media-left">
                                                    <img src="assets/images/menu-icons/plagiarism.svg" loading="lazy" decoding="async" alt="盗作チェッカー" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>盗用・剽窃レポート</h5>
                                                    <p>標準/高度な盗用・剽窃チェックレポートを提供します</p>
                                                </div>
                                            </div>
                                        </a>
                                        <a href="https://www.trinka.ai/jp/features/publication-readiness-checks" (click)="closeCanvasMenu()">
                                            <div class="media" (click)="closeCanvasMenu()">
                                                <div class="media-left">
                                                    <img src="assets/images/menu-icons/publications.svg" loading="lazy" decoding="async" alt="出版準備チェック" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>出版適正チェック</h5>
                                                    <p>原稿を20以上のチェックポイントから査定し評価します</p>
                                                </div>
                                            </div>
                                        </a>
                                        <!-- <a [routerLink]="['/features/journal-finder']">
                                            <div class="media" (click)="closeCanvasMenu()">
                                                <div class="media-left">
                                                    <img src="assets/images/menu-icons/journal-finder.svg" loading="lazy" decoding="async" alt="Journal Finder" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>ジャーナルファインダー</h5>
                                                    <p>論文に適したジャーナルを素早くご提案</p>
                                                </div>
                                            </div>
                                        </a> -->
                                        <a [routerLink]="['/features/citation-checker']">
                                            <div class="media" (click)="closeCanvasMenu()">
                                                <div class="media-left">
                                                    <img src="assets/images/menu-icons/citation-checker.svg" loading="lazy" decoding="async" alt="引用チェッカー" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>引用チェックツール</h5>
                                                    <p>自動分析で引用の質を高めます</p>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                                <div class="menu-card hr-line c-card"></div>
                                <div class="menu-card apps-card c-card">
                                    <h3 class="mb-40">アプリ</h3>
                                    <div class="media-card gap-sm">
                                        <a [routerLink]="['/trinkacloud']">
                                            <div class="media align-items-center"  (click)="closeCanvasMenu()">
                                                <div class="media-left">
                                                    <img src="assets/images/menu-icons/cloud.svg" loading="lazy" decoding="async" alt="Cloud" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>Trinka Cloud</h5>
                                                </div>
                                            </div>
                                        </a>
                                        <a [routerLink]="['/wordplugin']">
                                            <div class="media align-items-center"  (click)="closeCanvasMenu()">
                                                <div class="media-left">
                                                    <img src="assets/images/menu-icons/word-addin.svg" loading="lazy" decoding="async" alt="Word Add-in" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>Wordアドイン</h5>
                                                </div>
                                            </div>
                                        </a>
                                        <a href="https://www.trinka.ai/jp/ms-word-addin-for-mac">
                                            <div class="media align-items-center" (click)="closeCanvasMenu()">
                                                <div class="media-left">
                                                    <img src="assets/images/menu-icons/word-addin.svg" loading="lazy" decoding="async" alt="Word Add-in Lite" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>WordアドインLite</h5>
                                                </div>
                                            </div>
                                        </a>
                                        <a [routerLink]="['/browser-plugin']">
                                            <div class="media align-items-center" (click)="closeCanvasMenu()">
                                                <div class="media-left">
                                                    <img src="assets/images/menu-icons/browser-plugin.svg" loading="lazy" decoding="async" alt="Browser Plugins" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>ブラウザプラグイン</h5>
                                                </div>
                                            </div>
                                        </a>
                                        <!-- <div class="btn-group d-xl-block d-none">
                                            <a  id="GCChromeButton" href="https://chrome.google.com/webstore/detail/trinka-ai-for-chrome/bbcmnbnmngpeofmpcdlcfalbniefegbp" target="_blank" class="filled-btn"><img src="assets/images/NewChromeIcon.svg" loading="lazy" decoding="async" width="32" height="32" alt="chrome">Chrome</a>
                                            <a  id="GCFirFoxButton" href="https://addons.mozilla.org/en-US/firefox/addon/trinka-ai-firefox-browser/" target="_blank" class="filled-btn"><img src="assets/images/NewFirefoxIcon.svg" loading="lazy" decoding="async"  width="32" height="32" alt="firefox ">Firefox</a>
                                            <a  id="GCEdgeButton" href="https://microsoftedge.microsoft.com/addons/detail/trinka-ai-for-edge/kjhkcgjfbpppkbhhaocagkmfkkiibeap" target="_blank" class="filled-btn"><img src="assets/images/EdgeWhite_BGAndOutline.svg" loading="lazy" decoding="async"  width="32" height="32" alt="edge">Edge</a>
                                        </div> -->
                                    </div>
                                </div>
                            </div>
                        </li>
                    <!--/.mega-menu-content-->
                    </ul>
                    <!--/.dropdown-menu -->
                </li>
                <li class="nav-item dropdown dropdown-mega" >
                    <p class="nav-link dropdown-toggle" (click)="toggleClass($event)" data-toggle="dropdown"><span>法人向けサービス</span> <img src="assets/icons/chevron-up.svg" alt="アイコン" /></p>
                    <ul class="dropdown-menu mega-menu">
                        <li class="mega-menu-content row">
                            <div class="col-12 dflex mega-card">
                                <div class="menu-card trinka-business-menu">
                                    <h3 (click)="closeCanvasMenu()"><a [routerLink]="['/enterprise/confidential-data-plan-for-grammar-checker']">機密データ保護プラン</a></h3>
                                        
                                    <!-- <p class="menu-subtitle">最高レベルのセキュリティが求められる企業・団体専用の法人向けプランです</p> -->
                                    <a [routerLink]="['/enterprise/confidential-data-plan-for-grammar-checker']">
                                        <p class="menu-subtitle">最高レベルのセキュリティが求められる企業・団体専用の法人向けプランです</p>
                                        <div class="media-card gap-sm" (click)="closeCanvasMenu()">
                                            <img src="assets/images/only-enterprise-jp.png" class="img-fluid d-lg-block d-none" width="280" alt="企業 - 英文校正">
                                        </div>
                                    </a>
                                    <div class="media-card gap-sm" (click)="closeCanvasMenu()">
                                        <!-- <a [routerLink]="['/enterprise/confidential-data-plan-for-grammar-checker']">
                                            <video class="vid-video" id="myVideo" playsinline autoplay loop muted oncanplay="this.play()" onloadedmetadata="this.muted = true" loading="lazy">
                                                <source src="assets/images/video/data-sensitive-video-menu.mp4#t=0.1" type="video/mp4">
                                                Your browser does not support the video element. Kindly update it to latest version.
                                            </video>
                                        </a> -->
                                        <!-- <a href="" (click)="closeCanvasMenu()">
                                            <div class="media">
                                                <div class="media-left">
                                                    <img src="assets/images/menu-icons/style-guide.svg" loading="lazy" decoding="async" alt="style-guide" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>Style Guide</h5>
                                                </div>
                                            </div>
                                        </a> -->
                                    </div>
                                </div>
                                <div class="menu-card trinka-business-menu industries">
                                    <h3 (click)="closeCanvasMenu()"><a [routerLink]="['/enterprise']">分野</a></h3>
                                    <p class="menu-subtitle">分野・業界に特化した機能</p>
                                    <div class="media-card gap-sm">
                                        <a [routerLink]="['/enterprise/academic-institutions']">
                                            <div class="media align-items-center" (click)="closeCanvasMenu()">
                                                <div class="media-left">
                                                    <img src="assets/images/menu-icons/academic.svg" loading="lazy" decoding="async" alt="学術機関/大学 - 英文校正" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>学術研究機関</h5>
                                                </div>
                                            </div>
                                        </a>
                                        <a [routerLink]="['/enterprise/life-sciences-medicine-and-pharma']">
                                            <div class="media align-items-center" (click)="closeCanvasMenu()">
                                                <div class="media-left">
                                                    <img src="assets/images/menu-icons/life-science.svg" loading="lazy" decoding="async" alt="ライフサイエンス - 英文校正" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>ライフサイエンス、医療・製薬</h5>
                                                </div>
                                            </div>
                                        </a>
                                        <a [routerLink]="['/enterprise/language-services-publishing-and-media']">
                                            <div class="media align-items-center" (click)="closeCanvasMenu()">
                                                <div class="media-left">
                                                    <img src="assets/images/menu-icons/language-services.svg" loading="lazy" decoding="async" alt="言語サービス - 英文校正" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>言語サービス、出版、メディア</h5>
                                                </div>
                                            </div>
                                        </a>
                                        <a [routerLink]="['/enterprise/k12-and-elearning']">
                                            <div class="media align-items-center" (click)="closeCanvasMenu()">
                                                <div class="media-left">
                                                    <img src="assets/images/menu-icons/k-12.svg" loading="lazy" decoding="async" alt="K-12とEラーニング - AI 英文校正" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>教育＆Eラーニング</h5>
                                                </div>
                                            </div>
                                        </a>
                                        <a [routerLink]="['/enterprise/technology-platforms']">
                                            <div class="media align-items-center" (click)="closeCanvasMenu()">
                                                <div class="media-left">
                                                    <img src="assets/images/menu-icons/case-study.svg" loading="lazy" decoding="async" alt="テクノロジープラットフォーム - AI 英文校正" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>テクノロジー・プラットフォーム</h5>
                                                </div>
                                            </div>
                                        </a>
                                        <!-- <a [routerLink]="['/features/legal-writing']" (click)="closeCanvasMenu()">
                                            <div class="media">
                                                <div class="media-left">
                                                    <img src="assets/images/menu-icons/legal-writing.svg" loading="lazy" decoding="async" alt="Legal Firms" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>Legal Firms</h5>
                                                </div>
                                            </div>
                                        </a> -->
                                    </div>
                                </div>
                                <div class="menu-card trinka-business-menu">
                                    <h3 (click)="closeCanvasMenu()"><a [routerLink]="['/enterprise']">開発者向け</a></h3>
                                    <p class="menu-subtitle">先進のソリューションでシステムを強化</p>
                                    <div class="media-card gap-sm">
                                        <a [routerLink]="['/enterprise/grammar-checker-api']">
                                            <div class="media align-items-center" (click)="closeCanvasMenu()" >
                                                <div class="media-left">
                                                    <img src="assets/images/menu-icons/api.svg" loading="lazy" decoding="async" alt="API - ai英文校正" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>API</h5>
                                                </div>
                                            </div>
                                        </a>
                                        <a [routerLink]="['/enterprise']" fragment="javascript">
                                            <div class="media align-items-center" (click)="closeCanvasMenu()" >
                                                <div class="media-left">
                                                    <img src="assets/images/menu-icons/js.svg" loading="lazy" decoding="async" alt="JS - 英文 チェック" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>JavaScript(JS)</h5>
                                                </div>
                                            </div>
                                        </a>
                                        <a [routerLink]="['/enterprise']" fragment="onpremise">
                                            <div class="media align-items-center" (click)="closeCanvasMenu()" >
                                                <div class="media-left">
                                                    <img src="assets/images/menu-icons/premises.svg" loading="lazy" decoding="async" alt="オンプレミス - 英文校正" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>オンプレミス</h5>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </li>
                    <!--/.mega-menu-content-->
                    </ul>
                    <!--/.dropdown-menu -->
                </li>
                <li class="nav-item dropdown">
                    <p class="nav-link dropdown-toggle" (click)="toggleClass($event)" data-toggle="dropdown"><span>プランと料金</span> <img src="assets/icons/chevron-up.svg" alt="アイコン" /></p>
                    <ul class="dropdown-menu" id="planPricing">
                        <li class="row single-menu">
                            <div class="col-12 dflex mega-card">
                                <div class="menu-card">
                                    <div class="media-card gap-sm">
                                        <a [routerLink]="['/pricing']">
                                            <div class="media align-items-center" (click)="closeCanvasMenu()">
                                                <div class="media-left">
                                                    <img src="assets/images/menu-icons/pricing.svg" loading="lazy" decoding="async" alt="価格設定 - 英文校正" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>料金</h5>
                                                </div>
                                            </div>
                                        </a>
                                        <a [routerLink]="['/features/credits']">
                                            <div class="media align-items-center" (click)="closeCanvasMenu()">
                                                <div class="media-left">
                                                    <img src="assets/images/menu-icons/credits-trinka.svg" loading="lazy" decoding="async" alt="クレジット - 文法 チェック" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>ポイント (Credit)</h5>
                                                </div>
                                            </div>
                                        </a>
                                        <a [routerLink]="['/local-invoice']">
                                            <div class="media align-items-center" (click)="closeCanvasMenu()">
                                                <div class="media-left">
                                                    <img src="assets/images/menu-icons/local-invoice.svg" loading="lazy" decoding="async" alt="請求書 - 英文チ ェッカー" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>お支払い方法</h5>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </li>
                <li class="nav-item dropdown">
                    <p class="nav-link dropdown-toggle" (click)="toggleClass($event)" data-toggle="dropdown"><span>無料ツール</span> <img src="assets/icons/chevron-up.svg" alt="アイコン" /></p>
                    <ul class="dropdown-menu">
                        <li class="row single-menu">
                            <div class="col-12 dflex mega-card">
                                <div class="menu-card">
                                    <div class="media-card gap-sm">
                                        <a [routerLink]="['/grammar-checker']">
                                            <div class="media align-items-center" (click)="closeCanvasMenu()">
                                                <div class="media-left">
                                                    <img src="assets/images/menu-icons/grammar-checker.svg" loading="lazy" decoding="async" alt="文法 チェック" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>文法チェッカー</h5>
                                                </div>
                                            </div>
                                        </a>
                                        <a [routerLink]="['/paraphrasing-tool']">
                                            <div class="media align-items-center" (click)="closeCanvasMenu()">
                                                <div class="media-left">
                                                    <img src="assets/images/menu-icons/pharaphraser.svg" loading="lazy" decoding="async" alt="言い換えツール" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>パラフレーズツール</h5>
                                                </div>
                                            </div>
                                        </a>
                                        <a [routerLink]="['/ai-content-detector']">
                                            <div class="media align-items-center" (click)="closeCanvasMenu()">
                                                <div class="media-left">
                                                    <img src="assets/images/menu-icons/ai-detector.svg" loading="lazy" decoding="async" alt="AIコンテンツ検出器" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>AI生成コンテンツ検出ツール</h5>
                                                </div>
                                            </div>
                                        </a>
                                        <a [routerLink]="['/academic-phrasebank']">
                                            <div class="media align-items-center" (click)="closeCanvasMenu()">
                                                <div class="media-left">
                                                    <img src="assets/images/menu-icons/phrasebank.svg" loading="lazy" decoding="async" alt="phrasebank" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>アカデミックフレーズバンク</h5>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </li>
                <li class="nav-item dropdown">
                    <p class="nav-link dropdown-toggle" (click)="toggleClass($event)" data-toggle="dropdown"><span>リソース</span> <img src="assets/icons/chevron-up.svg" alt="アイコン" /></p>
                    <ul class="dropdown-menu">
                        <li class="row single-menu">
                            <div class="col-12 dflex mega-card">
                                <div class="menu-card">
                                    <div class="media-card gap-sm">
                                        <a [routerLink]="['/case-study']">
                                            <div class="media align-items-center" (click)="closeCanvasMenu()">
                                                <div class="media-left">
                                                    <img src="assets/images/menu-icons/case-study.svg" loading="lazy" decoding="async" alt="ホワイトペーパー - 英文校正" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>事例紹介</h5>
                                                </div>
                                            </div>
                                        </a>
                                        <a target="_blank" href="https://www.trinka.ai/jp/blog/">
                                            <div class="media align-items-center" (click)="closeCanvasMenu()">
                                                <div class="media-left">
                                                    <img src="assets/images/menu-icons/blogs.svg" loading="lazy" decoding="async" alt="ブログ" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>ブログ</h5>
                                                </div>
                                            </div>
                                        </a>
                                        <a  href="news">
                                            <div class="media align-items-center" (click)="closeCanvasMenu()" data-bs-dismiss="offcanvas">
                                                <div class="media-left">
                                                    <img src="assets/images/menu-icons/news.svg" loading="lazy" decoding="async" alt="news" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>ニュース</h5>
                                                </div>
                                            </div>
                                        </a>
                                        <a href="https://www.trinka.ai/jp/videos">
                                            <div class="media align-items-center" (click)="closeCanvasMenu()">
                                                <div class="media-left">
                                                    <img src="assets/images/menu-icons/videos.svg" loading="lazy" decoding="async" alt="動画" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>動画</h5>
                                                </div>
                                            </div>
                                        </a>
                                        <a [routerLink]="['/trinka-vs-grammarly-vs-language-tool']">
                                            <div class="media align-items-center" (click)="closeCanvasMenu()">
                                                <div class="media-left">
                                                    <img src="assets/images/menu-icons/whitepaper.svg" loading="lazy" decoding="async" alt="ホワイトペーパー - 英文校正" />
                                                </div>
                                                <div class="media-body">
                                                    <h5>他の文法チェックツールとの比較</h5>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </li>
                <!-- <li class="nav-item">
                    <a class="nav-link" [routerLink]="['/aboutus']" (click)="closeCanvasMenu()"><span>About Us</span></a>
                </li> -->
            </ul>
            <!-- /.offcanvas-footer -->
          </div>
          <!-- /.offcanvas-body -->
        </div>
        <div class="offcanvas-backdrop fade" (click)="closeCanvasMenu()" [ngClass]="{'show': isBackdropActive}"></div>
        <!-- /.navbar-collapse -->
        <div class="navbar-other w-100 d-flex ms-auto justify-content-end">
          <ul class="navbar-nav flex-row align-items-center ms-auto">
            <li class="nav-item">
                <div class="btn-group-header">
                    <a id="SignupForFree" class="btn-signup" href="https://cloud.trinka.ai/signup?_rg=JP" target="_blank">
                        無料で登録する
                    </a>
                    <a id="loginButtons" class="btn-login" href="https://cloud.trinka.ai/signin?_rg=JP" target="_blank">
                        <span>ログイン </span>
                    </a>
                </div>   
            </li>
            <!-- <li class="nav-item"><a class="nav-link" data-toggle="offcanvas" data-bs-target="#offcanvas-info"><i class="uil uil-info-circle"></i></a></li> -->
            <li class="nav-item d-xl-none">
                <button class="hamburger offcanvas-nav-btn" aria-label="英文校正" id="hamburger-menu" (click)="toggleOffCanvasMenu()"><span></span><span></span><span></span></button>
            </li>
          </ul>
        
        </div>
        <!-- /.navbar-other -->
        <div class="language_sections" id="languageDropDown">
            <i class="fa fa-globe" aria-hidden="true"></i>
            <span>日本語</span>
            <ul class="drop">
                <li>
                    
                    <a href="https://www.trinka.ai/">English</a>
                </li>
                <li class="selected">
                    <i class="fa fa-check" aria-hidden="true"></i>
                    <a href="https://www.trinka.ai/jp/">
                        日本語
                    </a>
                </li>
                <li>
                    <a href="https://trinka.enago.cn/">
                        简体中文
                    </a>
                </li>
                <li>
                    <a href="https://www.trinka.ai/tw/">
                        繁体中文
                    </a>
                </li>
                <li>
                    <a href="https://www.trinka.ai/kr/">
                        한국어
                    </a>
                </li>
                <li>
                    <a href="https://www.trinka.ai/es/">
                        Español
                    </a>
                </li>
                <li>
                    <a href="https://www.trinka.ai/pt/">
                        Português
                    </a>
                </li>
            </ul>
        </div>
      </div>
      <!-- /.container -->
    </nav>
    <!-- /.navbar -->
</header>
<!-- /header -->
